export const primaryColors = {
  red: '#F5222D',
  volcano: '#FA541C',
  orange: '#FA8C16',
  gold: '#FAAD14',
  yellow: '#FADB14',
  lime: '#A0D911',
  green: '#52C41A',
  cyan: '#13C2C2',
  blue: '#2D40CB',
  geekblue: '#2F54EB',
  purple: '#722ED1',
  magenta: '#EB2F96',
  grey: '#666666',
};

export const blue = {
  50: '#F3F7FF',
  100: '#E2EBFF',
  200: '#C4D7FF',
  300: '#9BBCFF',
  400: '#2B6FF6',
  500: '#242992',
  600: '#0C0554',
  700: '#070A1F',
};

export const yellow = {
  light: '#FFFCF0',
  light2: '#FEF3C7',
  medium: '#F6BF62',
  dark: '#B45309',
};

export const lime = {
  light: '#FBFDED',
  light2: '#F1F6D5',
  medium: '#DEF09B',
  dark: '#689A08',
};

export const green = {
  light: '#F6FDF8',
  light2: '#EAF7EB',
  medium: '#9EDEB6',
  dark: '#15803D',
};

export const teal = {
  light: '#EFFCFA',
  light2: '#DEF5F1',
  medium: '#98E5DC',
  dark: '#0AA5A8',
};

export const purple = {
  light: '#F9F5FE',
  light2: '#EEE5F9',
  medium: '#E7CBFF',
  dark: '#7F40C9',
};

export const pink = {
  light: '#FFF4F8',
  light2: '#FFE8F1',
  medium: '#FEBFDB',
  dark: '#CB1E83',
};

export const red = {
  light: '#FFF2F2',
  light2: '#FEE2E2',
  medium: '#EA5252',
  dark: '#A41616',
};

export const gray = {
  0: '#FDFDFD',
  50: '#F9F9F9',
  100: '#EBECEF',
  200: '#D4D7DD',
  300: '#BDC2CB',
  400: '#A7ADB9',
  500: '#898E9A',
  600: '#6C717C',
  700: '#50545F',
  800: '#353A44',
  900: '#141414',
};
